import React, { Component } from "react";
import NumberFormat from "react-number-format";

class BudgetVote extends Component {
  handleLikeClick = () => this.props.onVoteLike(this.props.id);
  handleDislikeClick = () => this.props.onVoteDislike(this.props.id);

  render() {
    const totalActions = this.props.likes + this.props.dislikes;
    const percentageLike = parseInt((this.props.likes / totalActions) * 100);
    const percentageDislike = parseInt((this.props.dislikes / totalActions) * 100);

    // LikeIcon
    const LikeIcon = () => {
      return (
        <>
          <img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_up.svg" width="20" alt=" " />
        </>
      );
    };

    // DislikeIcon
    const DislikeIcon = () => {
      return (
        <>
          <img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_down.svg" width="20" alt=" " />
        </>
      );
    };

    // Like Icon After Vote
    const LikeIconAfterVote = () => {
      return (
        <>
          <img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_up_line.svg" width="30" style={{ marginRight: "10px" }} alt=" " />
        </>
      );
    };

    // Dislike Icon After Vote
    const DislikeIconAfterVote = () => {
      return (
        <>
          <img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_down_line.svg" width="30" style={{ marginRight: "10px" }} alt=" " />
        </>
      );
    };

    return (
      <li className="App" style={{ marginBottom: "40px" }}>
        <div className="uk-card uk-card-default uk-card-small uk-border-rounded">
          <div className="uk-card-body">
            {this.props.icon}
            <h3 className="uk-card-title uk-text-bold uk-margin-small" style={{ fontWeight: "800" }}>
              {this.props.title}
            </h3>
            <p className="uk-margin-small">{this.props.descr}</p>
          </div>
          <div className="uk-card-footer">
            

            {/* ToDo: to enable the users to vote, uncomment code from line 63:78 and add //this.props.isUserVoted &&// into line 80 */}
            {/* {!this.props.isUserVoted && (
              <>
                <ul className="uk-grid uk-grid-small uk-child-width-1-2 uk-text-center uk-grid">
                  <li>
                    <button onClick={this.handleLikeClick} className="uk-button uk-button-secondary uk-border-rounded uk-width-1-1" style={{ background: "#4CAF50" }}>
                      <LikeIcon />
                    </button>
                  </li>
                  <li>
                    <button onClick={this.handleDislikeClick} className="uk-button uk-button-secondary uk-border-rounded uk-width-1-1" style={{ background: "#f44336" }}>
                      <DislikeIcon />
                    </button>
                  </li>
                </ul>
              </>
            )} */}

            { (
              <>
                <ul className="uk-grid uk-grid-collapse uk-child-width-1-2 uk-text-center" uk-grid>
                  <li className="uk-text-large" style={{ color: "#4CAF50" }}>
                    <LikeIconAfterVote />
                    {percentageLike} %
                  </li>
                  <li className="uk-text-large" style={{ color: "#f44336" }}>
                    <DislikeIconAfterVote />
                    {percentageDislike} %
                  </li>
                </ul>
                <NumberFormat value={totalActions} displayType={"text"} thousandSeparator={true} /> Voted
              </>
            )}
          </div>
        </div>
      </li>
    );
  }
}

export default BudgetVote;
